import { largeUploadByIdSelector, Upload } from '@air/redux-uploader';
import { useCreateLargeUpload } from '@air/upload-utils';
import { useCallback } from 'react';

import { PrivateUploadTaskParams } from '~/components/Upload/hooks/types';
import { metadataForPublicUploadSelector } from '~/store/publicUploadMetadata/selectors';
import { useAirStore } from '~/utils/ReduxUtils';
import { sendCreatePublicMultipartUpload } from '~/utils/uploadApi/publicUploadApi/publicLargeUploadApi';

interface CreateLargePublicUploadParams {
  uploadId: Upload['id'];
  onUploadStarted: PrivateUploadTaskParams['onUploadStarted'];
  onError: PrivateUploadTaskParams['onError'];
}

export const useCreateLargePublicUpload = () => {
  const store = useAirStore();
  const { createLargeUpload } = useCreateLargeUpload();

  const createLargePublicUpload = useCallback(
    async ({ onUploadStarted, uploadId, onError }: CreateLargePublicUploadParams) => {
      const upload = largeUploadByIdSelector(store.getState(), uploadId);
      if (upload) {
        await createLargeUpload({
          getLargeUploadUrlInfo: async () => {
            const uploadMetadata = metadataForPublicUploadSelector(store.getState(), uploadId);
            if (uploadMetadata && uploadMetadata.sessionId) {
              return sendCreatePublicMultipartUpload({
                apiUploadData: upload.apiUploadData,
                shortBoardId: uploadMetadata.shortBoardId,
                sessionId: uploadMetadata.sessionId,
              });
            }
          },
          onError,
          upload,
          onUploadStarted,
        });
      }
    },
    [createLargeUpload, store],
  );

  return {
    createLargePublicUpload,
  };
};
